<template>
  <b-container
    fluid
    style="
      background-color: #33383a;
      width: 100%;
      padding-top: 60px;
      padding-bottom: 25px;
    "
    class="footer no-padding-top-small"
  >
    <b-row align-h="center" style="width: 100%">
      <b-col cols="12" style="max-width: 1400px" class="pl-pr-0-sm">
        <b-row class="pt-5 hide-when-big footeraccordian">
          <b-col cols="12" class="pl-0 pr-0">
            <VueFaqAccordion
              :items="myItemsProduct"
              :activeColor="activeColorAccordian"
              :borderColor="borderColorAccordian"
              :fontColor="activeColorAccordian"
            >
              <b-col class="pt-4 pl-0 pr-0">
                <b-row>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/product">Overview</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/select_t1">Truthbrush Tracker</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/select_t2">Tracker Pro</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/select_t3">Truthbrush Skin</a>
                  </b-col>
                </b-row>
              </b-col>
            </VueFaqAccordion>
          </b-col>
          <b-col cols="12">
            <hr class="footer-spec-line" />
          </b-col>
          <b-col cols="12" class="footeraccordian pl-0 pr-0">
            <VueFaqAccordion
              :items="myItemsSolutions"
              :activeColor="activeColorAccordian"
              :borderColor="borderColorAccordian"
              :fontColor="activeColorAccordian"
              class="moreinfo"
            >
              <b-col class="pt-4 pl-0 pr-0">
                <b-row>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/provider">For Dentist</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="https://app.truthbrush.com">Dashboard</a>
                  </b-col>
                </b-row>
              </b-col>
            </VueFaqAccordion>
          </b-col>

          <b-col cols="12">
            <hr />
          </b-col>
          <b-col cols="12" class="footeraccordian pl-0 pr-0">
            <VueFaqAccordion
              :items="myItemsSupport"
              :activeColor="activeColorAccordian"
              :borderColor="borderColorAccordian"
              :fontColor="activeColorAccordian"
              class="moreinfo"
            >
              <b-col class="pt-4 pl-0 pr-0">
                <b-row>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/faq">FAQ</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/contact">Contact Support</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/refund">Return and Refund</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/warranty">Factory Warranty</a>
                  </b-col>
                </b-row>
              </b-col>
            </VueFaqAccordion>
          </b-col>

          <b-col cols="12">
            <hr />
          </b-col>
          <b-col cols="12" class="footeraccordian pl-0 pr-0">
            <VueFaqAccordion
              :items="myItemsCompany"
              :activeColor="activeColorAccordian"
              :borderColor="borderColorAccordian"
              :fontColor="activeColorAccordian"
              class="moreinfo"
            >
             <b-col class="pt-4 pl-0 pr-0">
                <b-row>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/about">Our Story</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/rewards">Referral Program</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/contact">Contact Us</a>
                  </b-col>
                </b-row>
              </b-col>
            </VueFaqAccordion>
          </b-col>

          <b-col cols="12">
            <hr />
          </b-col>
          <b-col cols="12" class="footeraccordian pl-0 pr-0">
            <VueFaqAccordion
              :items="myItemsLegal"
              :activeColor="activeColorAccordian"
              :borderColor="borderColorAccordian"
              :fontColor="activeColorAccordian"
              class="moreinfo"
            >
              <b-col class="pt-4 pl-0 pr-0">
                <b-row>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/tc">Terms of Services</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/compliance">Compliance</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                    <a href="/#/privacy">Privacy Policy</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                   <a href="/#/cookies">Use of Cookies</a>
                  </b-col>
                  <b-col cols="6" class="footeraccordianitem">
                   <a href="/#/distributor">Distributor Policy</a>
                  </b-col>
                </b-row>
              </b-col>
            </VueFaqAccordion>
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>

        <b-row class="pt-0 hide-when-small">
          <b-col style="width: 20%" class="pt-4">
            <b-row class="footerh1"> Products </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/product">Overview</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/select_t1">Truthbrush Tracker</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/select_t2">Truthbrush Tracker Pro</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/select_t3">Truthbrush Skin</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/select_t5">Truthbrush Hub</a>
              </b-col>
            </b-row>
          </b-col>

          <b-col style="width: 20%" class="pt-4">
            <b-row class="footerh1"> Solutions </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/provider">For Dentist</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="https://app.truthbrush.com">Dashboard</a>
              </b-col>
            </b-row>
          </b-col>

          <b-col style="width: 20%" class="pt-4">
            <b-row class="footerh1"> Support </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/faq">FAQ</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/contact">Get Support</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/refund">Return and Refund</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/warranty">Factory Warranty</a>
              </b-col>
            </b-row>
          </b-col>

          <b-col style="width: 20%" class="pt-4">
            <b-row class="footerh1"> Company </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/about">Our Story</a>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/rewards">Referral Program</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="https://www.amazon.com/candibell">Amazon Store</a>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/contact">Contact Us</a>
              </b-col>
            </b-row>
          </b-col>

          <b-col style="width: 20%" class="pt-4">
            <b-row class="footerh1"> Legal </b-row>
            <b-row class="pt-1 footerlink">
              <b-col class="pl-0 pr-0">
                <a href="/#/tc">Terms of Services</a>
              </b-col>
            </b-row>
            <b-row class="pt-1 footerlink">
              <b-col class="pl-0 pr-0">
                <a href="/#/compliance">Compliance</a>
              </b-col>
            </b-row>
            <b-row class="pt-1 footerlink">
              <b-col class="pl-0 pr-0">
                <a href="/#/privacy">Privacy Policy</a>
              </b-col>
            </b-row>

            <b-row class="pt-1 footerlink">
              <b-col class="pl-0 pr-0">
                <a href="/#/cookies">Use of Cookies</a>
              </b-col>
            </b-row>
            <b-row class="pt-1 footerlink">
              <b-col class="pl-0 pr-0 footerlink">
                <a href="/#/distributor">Distributor Policy</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row align-v="center" class='pt-4 hide-when-small'>
          <b-col md="12" cols="12">
            <b-row style="">
              <b-col class="pl-0 pr-0 align-center-small">
                <span class="footerh1" style='vertical-align: text-bottom;'>
                  <b-img src='img/Logo-white.png' style='height:20px'></b-img>
                </span>
              
                <a
                  href="https://www.facebook.com/Truthbrush-100716711725980"
                  class="iconlink first-icon-link"
                  style="padding-left: 25px; color:#DFE0E1;font-size:1.4rem"
                >
                  <b-img src="img/facebook.png" />
                  Facebook
                </a>
                <a
                  href="https://www.instagram.com/truthbrushtracker"
                  class="iconlink"
                  style="padding-left: 25px; color:#DFE0E1;font-size:1.4rem"
                >
                  <b-img src="img/instagram.png" />
                  Instagram
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row align-v="center" class="mt-5 mb-5">
          <b-col md="6" class="pt-2">
            <b-row class='pb-1'>
              <b-col
                class="pl-0 pr-0 align-center-small"
                style="color: #91959A; font-size: 12px; padding-bottom: 0px"
                >&copy;2023.
                <a
                  href="https://www.truthbrush.com"
                  style="color: #91959A; font-size: 12px"
                  >Truthbrush &#169;</a
                >
                All Rights Reserved.</b-col
              >
            </b-row>
            <b-row class>
              <b-col
                class="pl-0 pr-0 align-center-small"
                style="color: #91959A; font-size: 12px; padding-bottom: 5px"
                >
                Truthbrush Tracker and Truthbrush Hub are trade names used by Candibell Inc. Apple and the
                Apple logo are trademarks of Apple Inc., registered in the U.S.
                and other countries. App Store is a service mark of Apple Inc.
                Google Play, the Google Play logo, and Android are trademarks of
                Google Inc. All other trademarks and trade names are properties
                of their respective owners.</b-col
              >
            </b-row>
          </b-col>

          <b-col md="6" cols="12" class="store-align">
            <a href="https://apps.apple.com/us/app/truthbrush/id1521192393"
              ><b-img src="img/app-store-dark.png" style="height: 40px"></b-img
            ></a>
            <a
              href="https://play.google.com/store/apps/details?id=com.candibell.brush"
              ><b-img
                src="img/google-play-dark.png"
                style="height:40px"
              ></b-img
            ></a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VueFaqAccordion from "vue-faq-accordion";
export default {
  name: "nav-footer",
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      activeColorAccordian: "white",
      borderColorAccordian: "transparent",
      myItemsProduct: [
        {
          title: "Products",
          value: "",
        },
      ],
      myItemsSolutions: [
        {
          title: "Solutions",
          value: "",
        },
      ],
      myItemsSupport: [
        {
          title: "Support",
          value: "",
        },
      ],
      myItemsCompany: [
        {
          title: "Company",
          value: "",
        },
      ],
      myItemsLegal: [
        {
          title: "Legal",
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@media (max-width: 1040px) {
  .padding-top-small {
    padding-top: 7px;
  }
  .padding-top-small .first-icon-link {
    padding-left: 0px !important;
  }
}

@media (max-width: 768px) {
  .store-align {
    text-align: center !important;
    padding-top: 40px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .store-align img {
    width: 120px !important;

    .footerh1 {
      font-size: 16px;
    }
  }
}

.footeraccordianitem {
  text-align: left;
  padding-left:0!important;
  padding-right:0!important;
  padding-top:15px;
}

.footeraccordianitem a,
.footeraccordianitem a:hover {
  color: white;
}
.footer-spec-line {
  color: white;
  background-color: white;
}

.footeraccordian .accordion__toggle-button::after,
.footeraccordian .accordion__toggle-button::before {
  background: white !important;
}

.footeraccordian .accordion__value{
  padding-left: 0!important;
  padding-right: 0!important;
}

.footeraccordian hr {
  margin: 5px 0px;
}

.footeraccordian .accordion__title-text {
  font-size: 20px!important;
}

.footeraccordian .accordion__title {
  padding: 0 !important;
}

.footeraccordian hr {
  background: white !important;
}

.store-align {
  text-align: right;
}
.store-align img {
  margin-left: 10px;
}

.footerh1 {
  color: white;
  font-size: 18px;
  padding-bottom: 15px;
}

.footerlink a,
.footerlink a:hover {
  color: #DFE0E1;
  font-size: 12px;
}

.footerlink {
  padding-bottom: 0px;
  padding-top: 0px !important;
}

.iconlink,
.iconlink:hover {
  color: #12b8ed;
}
</style>

